import type { ProductStatusInfo } from "../hooks"

export const getStatusBadgeText = (
  statusInfo: ProductStatusInfo | undefined
): string | undefined => {
  if (!statusInfo) return undefined

  const shouldShowBadge =
    statusInfo.status === "low-stock" || statusInfo.status === "limited"

  return shouldShowBadge ? statusInfo.statusDescription : undefined
}
